<template>
    <div class="table-row"
         :style="{ height: 'auto' }">
        <div class="pricing">
            <div class="table-page">
                <div v-if="!showMobileVersion"
                     class="table-head">
                    <div class="table-row">
                        <div class="th"></div>
                        <div class="th">GROUP NAME</div>
                        <div class="th">
                            <span v-if="schoolCountry === 'England'">YEARS</span>
                            <span v-else>GRADES</span>
                        </div>
                        <div class="th">TIME</div>
                        <div class="th">COST</div>
                        <div class="th">ENROLLED/MAX</div>
                        <div class="th">STATUS</div>
                    </div>
                </div>
                <div class="table-body">
                    <camp-pricing-row v-for="pricing of pricings"
                                      :key="campId * pricing.id"
                                      :readonly="readonly"
                                      :id="pricing.id"
                                      :name="pricing.name"
                                      :time-from="pricing.timeFrom"
                                      :time-to="pricing.timeTo"
                                      :price="pricing.price"
                                      :age-from="pricing.ageFrom"
                                      :age-to="pricing.ageTo"
                                      :grade-from="pricing.gradeFrom"
                                      :grade-to="pricing.gradeTo"
                                      :enrolled="pricing.enrolled"
                                      :max-enroll="pricing.maxEnroll"
                                      :activity-status="pricing.activityStatus">
                    </camp-pricing-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { ResizeMobileMixin } from '@/mixins/ResizeMobileMixin';

    export default {
        name: 'CampPricingsList',
        components: {
            CampPricingRow: () => import(/* webpackChunkName: "camps" */ './CampPricingRow')
        },
        props: {
            readonly: {
                type: Boolean,
                default: false
            },
            campId: {
                type: Number,
                required: true
            },
            pricings: {
                type: Array,
                required: true
            }
        },
        mixins: [ResizeMobileMixin(992)],
        computed: {
            ...mapGetters(['currencySign', 'schoolCountry'])
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../assets/colors';

    .table-body /deep/ .table-row {
        &:not(:last-child) {
            .td:not(:first-child) {
                border-bottom: 1px solid $ComplementaryBgTxtDarker;

                @media screen and (max-width: 991px) {
                    border-bottom: none;
                }
            }
        }

        @media screen and (max-width: 991px) {
            padding: 0 0 10px 0;
        }
    }

    .table-row {
        height: auto;
        margin-bottom: 10px;

        @media screen and (max-width: 991px) {
            box-shadow: none;
            padding-top: 0;

            &:not(:last-child) {
                margin-bottom: 10px;
                border-bottom: 1px solid $ComplementaryBgTxtDarker;
            }
        }
    }

    .table-head {
        .table-row {
            height: auto;
        }
    }

    .pricing {
        position: relative;
        width: 100%;

        /deep/ .td, /deep/ .th {
            padding: 0 !important;

            &:first-child {
                flex-basis: 5%;
            }

            &:nth-child(2) {
                flex-basis: 18%;
            }

            &:nth-child(3) {
                flex-basis: 11%;
            }

            &:nth-child(4) {
                flex-basis: 18%;
            }

            &:nth-child(5) {
                flex-basis: 19%;
            }

            &:nth-child(6) {
                flex-basis: 19%;
            }

            &:nth-child(7) {
                flex-basis: 9%;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/main/pages/camps/CampPricingsList.vue